import { useRef } from 'react';
import { STATUS } from '@kontentino/kontentino-constants/Posts';
import { ListPost } from 'types/PostDetail';
import { PostCommunicationRef } from 'app/modules/posts/modules/post/components/postCommunication/PostCommunicationProvider';
import { PostCommunicationContent } from 'app/modules/posts/modules/post/components/postCommunication/types/postCommunicationContent';
import { UserPermission } from 'constants/userPermission';
import { useUserPermissions } from 'app/hooks/useUserPermissions';
import { ApprovalThreadType } from '../types';

type Props = {
  post: ListPost;
  onPostProcessed?: () => void;
};

export const useApprovalCommunication = ({ post, onPostProcessed }: Props) => {
  const { hasSome } = useUserPermissions();
  const postCommunicationRef = useRef<PostCommunicationRef>(null);

  const canViewInternalComments = hasSome(
    UserPermission.POST_COMMUNICATION_INTERNAL_SHOW,
  );

  const isInternalApproval =
    post.status === STATUS.WAITING_FOR_INTERNAL_APPROVAL;

  const thread: ApprovalThreadType =
    isInternalApproval && canViewInternalComments ? 'internal' : 'client';

  const initialActiveContent =
    thread === 'internal'
      ? PostCommunicationContent.INTERNAL
      : PostCommunicationContent.CLIENT;

  return {
    postCommunicationRef,
    thread,
    initialActiveContent,
  };
};
